import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/zengdai/Workspace/vimwiki/Projects/Blogger/blogv3/src/components/posts-layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`Just cool ...`}</p>
    <h1>{`Feel the Power of Nix`}</h1>
    <p>{`To build a reproducible env is the Nix's Ultimate Power. You can live without NixOS or not using Home-Manager. But this one is the essential of Nix. This post is to illustrate what you can perform with Nix.`}</p>
    <h1>{`Direnv`}</h1>
    <p>{`Nix ❤ Direnv. These two are so powerful that it could be illegal to use both 😆. Direnv grants you seamless environment while Nix guarantees they are reliable and reproducible instantly. My rest blogs are merely snippets and tips to showcase/advertise this combination (all in my dotfiles `}<a parentName="p" {...{
        "href": "https://github.com/daizeng1984/dotfiles/tree/master/direnv"
      }}>{`repo`}</a>{`). BTW, direnv can `}<a parentName="p" {...{
        "href": "https://github.com/daizeng1984/dotfiles/blob/master/direnv/.direnvrc"
      }}>{`work with conda`}</a>{` too!`}</p>
    <h1>{`NodeJS`}</h1>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "nix"
    }}><pre parentName="div" {...{
        "className": "language-nix"
      }}><code parentName="pre" {...{
          "className": "language-nix"
        }}><span parentName="code" {...{
            "className": "token comment"
          }}>{`# Nixpkgs 20.09`}</span>{`
`}<span parentName="code" {...{
            "className": "token comment"
          }}>{`# no -g/global install needed! node_modules/.bin is in PATH when in this folder`}</span>{`
`}<span parentName="code" {...{
            "className": "token comment"
          }}>{`# { pkgs ? import <nixpkgs> {} }:`}</span>{`
`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{` pkgs `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`?`}</span>{` 
`}<span parentName="code" {...{
            "className": "token function"
          }}>{`import`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token keyword"
          }}>{`builtins`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span><span parentName="code" {...{
            "className": "token function"
          }}>{`fetchTarball`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{`
      name `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`"nixos-20.09"`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{`
      url `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`"https://codeload.github.com/NixOS/nixpkgs/tar.gz/20.09"`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{`
      sha256 `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`"1wg61h4gndm3vcprdcg7rc4s1v3jkm5xd7lw8r2f67w502y94gcy"`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{`
  `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span>{`
`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{`

pkgs`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span>{`mkShell `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{`
  buildInputs `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`with`}</span>{` pkgs`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`[`}</span>{`
    nodejs
    yarn
  `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`]`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{`

  shellHook `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`''
    export PATH="$PWD/node_modules/.bin/:$PATH"
    echo "🚀 nodejs ready!"
  ''`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{`

  MY_ENVIRONMENT_VARIABLE `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`"dummy"`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{`
`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span></code></pre></div>
    <p>{`Here usually you pin down to a particular nixpkgs to make sure the reproducibility. Remember `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`npm install -g`}</code>{`? Now it's not allowed and neither good practice. You just install to local `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`node_modules`}</code>{` folder and export the `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`node_modules/.bin`}</code>{` path.`}</p>
    <h1>{`Emscripten`}</h1>
    <p>{`Webassembly? Easy piece:`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "nix"
    }}><pre parentName="div" {...{
        "className": "language-nix"
      }}><code parentName="pre" {...{
          "className": "language-nix"
        }}><span parentName="code" {...{
            "className": "token keyword"
          }}>{`let`}</span>{`
   emscriptenPackages`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span>{`zlib
`}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`in`}</span>{` 
pkgs`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span>{`mkShell `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{`
  buildInputs `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`with`}</span>{` pkgs`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`[`}</span>{`
    emscripten
    emscriptenPackages`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span>{`zlib
    webfs `}<span parentName="code" {...{
            "className": "token comment"
          }}>{`# webfs -F -p 3000 to serve current folder`}</span>{`
  `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`]`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{`
`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span></code></pre></div>
    <p>{`Nixpkgs already has common emscriptenPackages ready but if you can compile your own as shown `}<a parentName="p" {...{
        "href": "https://github.com/NixOS/nixpkgs/blob/master/doc/languages-frameworks/emscripten.section.md#user-content-usage-2-pkgsbuildemscriptenpackage"
      }}>{`here`}</a>{`.`}</p>
    <h1>{`Rust`}</h1>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "nix"
    }}><pre parentName="div" {...{
        "className": "language-nix"
      }}><code parentName="pre" {...{
          "className": "language-nix"
        }}><span parentName="code" {...{
            "className": "token keyword"
          }}>{`let`}</span>{`
  moz_overlay `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` `}<span parentName="code" {...{
            "className": "token function"
          }}>{`import`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token keyword"
          }}>{`builtins`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span><span parentName="code" {...{
            "className": "token function"
          }}>{`fetchTarball`}</span>{` `}<span parentName="code" {...{
            "className": "token url"
          }}>{`https://github.com/mozilla/nixpkgs-mozilla/archive/master.tar.gz`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{`
  nixpkgs `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` `}<span parentName="code" {...{
            "className": "token function"
          }}>{`import`}</span>{` `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`<`}</span>{`nixpkgs`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`>`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{` overlays `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`[`}</span>{` moz_overlay `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`]`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{`
  ruststable `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span>{`nixpkgs`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span>{`latest`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span>{`rustChannels`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span>{`stable`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span>{`rust`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span>{`override `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{` extensions `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`[`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`"rust-src"`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`"clippy-preview"`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`"rls-preview"`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`"rust-analysis"`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`"rustfmt-preview"`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`]`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{`
`}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`in`}</span>{`
`}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`with`}</span>{` nixpkgs`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{`
mkShell `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{`
  buildInputs `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`[`}</span>{` 
    openssl 
    pkg`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`-`}</span>{`config
    nasm
    ruststable
    rustup
    cmake
    zlib 
  `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`]`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{`

  shellHook `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`''
    export PATH=$HOME/.cargo/bin:$PATH
  ''`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{`
`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span></code></pre></div>
    <p>{`New and fast evolving lang, you have to overlay nightly pkgs from Mozilla. Relax, nixpkgs master is stable than you thought!`}</p>
    <h1>{`Python`}</h1>
    <p>{`Install pkgs in read-only nix python is impossible. You either use local pip (virtual python env) or manage packages in nix. With nix, you don't need to worry about the native package like cython etc..`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "nix"
    }}><pre parentName="div" {...{
        "className": "language-nix"
      }}><code parentName="pre" {...{
          "className": "language-nix"
        }}><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span>{`
`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{`
`}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`let`}</span>{`
  pythonEnv `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` pkgs`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span>{`python38`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span>{`withPackages `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span>{`ps`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`[`}</span>{`
    ps`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span>{`numpy
    ps`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span>{`pytorch
    ps`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span>{`dateutil
  `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`]`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{`
`}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`in`}</span>{` pkgs`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span>{`mkShell `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{`
  buildInputs `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`with`}</span>{` pkgs`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`[`}</span>{`
    pythonEnv
    libffi
    openssl
  `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`]`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{`
`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span></code></pre></div>
    <p>{`If you are dealing with mostly pure py pkgs or has no admin permission, you might consider conda. It's also powerful: before my Nix age, conda is my environment pkgs manager. Another way is to use `}<a parentName="p" {...{
        "href": "https://github.com/DavHau/mach-nix/blob/master/examples.md"
      }}>{`mach-nix`}</a>{`, which can help pack pypi into nix pkgs.`}</p>
    <h1>{`C++`}</h1>
    <p>{`Nix is the out of box C++ dev pkg manager in *nix OS I'd say, since C++ pkgs are mostly low level and OS related. However, nix expression is not as good for incremental build, yet you can integrate with powerful like bazel etc. If you just need some scratch start, here you go:`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "nix"
    }}><pre parentName="div" {...{
        "className": "language-nix"
      }}><code parentName="pre" {...{
          "className": "language-nix"
        }}>{`
`}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`let`}</span>{`
  version `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`"0.1"`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{`
`}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`in`}</span>{` pkgs`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span>{`mkShell `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{`
  name `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`"my-cpp-app"`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{`
  src `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`"./."`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{`

  nativeBuildInputs `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`with`}</span>{` pkgs`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`[`}</span>{` cmake meson ninja `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`]`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{`
  `}<span parentName="code" {...{
            "className": "token comment"
          }}>{`# phases: unpackPhase -> configurePhase -> buildPhase -> installPhase`}</span>{`
  buildInputs `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`with`}</span>{` pkgs`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`[`}</span>{` 
    boost
    poco
  `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`]`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{`

  configurePhase `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`''
    cmake -G Ninja .
    #meson setup builddir
  ''`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{`

  buildPhase `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`''
    c++ -o main main.cpp -lPocoFoundation -lboost_system
    #meson compile
  ''`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{`

  installPhase `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`''
    mkdir -p $out/bin
    cp main $out/bin
    #cd builddir && meson compile
  ''`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{`

  enableParallelBuilding `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` `}<span parentName="code" {...{
            "className": "token boolean"
          }}>{`true`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{`
`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span></code></pre></div>
    <p>{`These buildPhase will be called in order if you build *.nix file. You can manually revoke them in nix-shell or just make it as Nix derivative and build.`}</p>
    <h1>{`🚧Jdk`}</h1>
    <p>{`TODO:`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "nix"
    }}><pre parentName="div" {...{
        "className": "language-nix"
      }}><code parentName="pre" {...{
          "className": "language-nix"
        }}>{`    buildInputs `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`with`}</span>{` pkgs`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`[`}</span>{` jdk11 `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`]`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{`
    
    shellHook `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`''
      export JAVA_HOME=`}<span parentName="span" {...{
              "className": "token interpolation"
            }}><span parentName="span" {...{
                "className": "token antiquotation important"
              }}>{`$`}</span><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`{`}</span>{`pkgs`}<span parentName="span" {...{
                "className": "token punctuation"
              }}>{`.`}</span>{`jdk11`}<span parentName="span" {...{
                "className": "token punctuation"
              }}>{`}`}</span></span>{`
      PATH="`}<span parentName="span" {...{
              "className": "token interpolation"
            }}><span parentName="span" {...{
                "className": "token antiquotation important"
              }}>{`$`}</span><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`{`}</span>{`pkgs`}<span parentName="span" {...{
                "className": "token punctuation"
              }}>{`.`}</span>{`jdk11`}<span parentName="span" {...{
                "className": "token punctuation"
              }}>{`}`}</span></span>{`/bin:$PATH"
    ''`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span></code></pre></div>
    <h2>{`Android`}</h2>
    <p><a parentName="p" {...{
        "href": "https://github.com/NixOS/nixpkgs/blob/master/pkgs/development/mobile/androidenv/examples/shell.nix"
      }}>{`https://github.com/NixOS/nixpkgs/blob/master/pkgs/development/mobile/androidenv/examples/shell.nix`}</a>{`
Finally, we got some updates from nix community for license issue.`}</p>
    <p>{`You'll need to accept a bunch of licenses, `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`config.androidenv.accept_licneses = true`}</code>{` only help some core licenses, you need to specify extra licenses`}</p>
    <h1>{`Non-Root`}</h1>
    <p>{`If this bothers you ...`}</p>
    <ol>
      <li parentName="ol">{`Namespace `}<code parentName="li" {...{
          "className": "language-text"
        }}>{`nix-user-chroot`}</code>{`. However, it cannot support `}<a parentName="li" {...{
          "href": "TODO"
        }}>{`tmux reattachment`}</a>{` (hope this is tmux fault).`}</li>
      <li parentName="ol">{`Proot allow tmux to reattach, however, it has limit os support for certain system call which is very hard to find out when it happens. `}</li>
      <li parentName="ol">{`Build your own stuff and troubleshooting all on your own.`}</li>
    </ol>
    <p>{`Namespace is recommended however in Mac it seems to be impossible.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      